import React from "react";
import { Route, Redirect } from "react-router-dom";
import * as UsersService from "../services/users/api_user";

const ProtectedRoute = props => {
  const { path, component: Component, render, ...rest } = props;

  const user = UsersService.getCurrentUser();

  return (
    <Route
      path={path}
      {...rest}
      render={props => {
        if (!user || user.id === undefined) return <Redirect to="/login" />;
        return Component ? <Component /> : render(props);
      }}
    />
  );
};

export default ProtectedRoute;



// WEBPACK FOOTER //
// ./src/User/ProtectedRoute.jsx